import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Store from 'store/store';
import { ModelPortfolioType } from 'store/modules/Meta/types';
import Icons from 'components/Icons';

const { connect, selectors } = Store;

const useStyles = makeStyles({
  '@global': {
    '.MuiAutocomplete-option': {
      fontSize: '13px',
      transform: 'translateZ(0)',
      backfaceVisibility: 'hidden'
    }
  },
  search: {
    width: '100%',
    backgroundColor: '#e5e5e5',
    borderRadius: '25px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    padding: '0.2rem 0.8rem 0 2.4rem'
  },
  input: {
    '&:before': {
      border: '0 !important'
    }
  },
  searchContainer: {
    width: '100%',
    position: 'relative'
  },
  searchIcon: {
    position: 'absolute',
    left: '8px',
    top: '10px'
  }
});

interface SearchTypes {
  onSelect: (val: ModelPortfolioType) => void;
  modelPortfolios: ModelPortfolioType[];
  isLoading: boolean;
  inputId?: string;
  data?: ModelPortfolioType[] | null;
}

const Search = ({
  onSelect,
  modelPortfolios,
  isLoading,
  inputId,
  data = null
}: SearchTypes) => {
  const initialOptions = data || modelPortfolios;
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState(initialOptions);
  const [searchValue, changeSearchValue] = useState('');
  const classes = useStyles();

  const includesFunds = options.some(
    option => option.type && option.type === 'f'
  );

  useEffect(() => {
    const filtered = [...initialOptions].filter(
      (modelPortfolio: ModelPortfolioType) => {
        const name = modelPortfolio.name.toLowerCase();
        const searchedVal = searchValue.toLowerCase();

        return name.indexOf(searchedVal) !== -1;
      }
    );
    setOptions(filtered);
    // eslint-disable-next-line
  }, [searchValue]);

  return (
    <div className={classes.searchContainer}>
      <Icons.SearchIcon className={classes.searchIcon} />
      <Autocomplete
        className={classes.search}
        open={open}
        id={inputId}
        onOpen={() => {
          if (options.length > 0) {
            setOpen(true);
          }
        }}
        onClose={() => {
          setOpen(false);
        }}
        blurOnSelect={true}
        getOptionLabel={(option: any) => option.name}
        options={options}
        loading={isLoading}
        onChange={(ev: any, val: any) => {
          onSelect(val);
          setOpen(false);
          changeSearchValue('');
        }}
        renderInput={(params: any) => {
          return (
            <TextField
              {...params}
              placeholder={`${includesFunds ? 'Select Fund or Portfolio' : 'Select Portfolio'}`}
              fullWidth
              variant="standard"
              inputProps={{
                ...params.inputProps,
                onChange: (ev: any) => {
                  changeSearchValue(ev.target.value);
                },
                value: searchValue
              }}
              InputProps={{
                ...params.InputProps,
                className: classes.input
              }}
            />
          );
        }}
      />
    </div>
  );
};

export default connect((state: any) => ({
  modelPortfolios: selectors.metaSelectors.modelPortfolios(state)
}))(Search);
